var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSendIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    "data-name": "Send",
    d: "M19.435.582A1.933 1.933 0 0017.5.079L1.408 4.76A1.919 1.919 0 00.024 6.281a2.253 2.253 0 001 2.1l5.036 3.096a1.3 1.3 0 001.61-.193l5.763-5.8a.734.734 0 011.06 0 .763.763 0 010 1.067l-5.773 5.8a1.324 1.324 0 00-.193 1.619l3.073 5.084a1.91 1.91 0 001.663.946 2.078 2.078 0 00.25-.01 1.95 1.95 0 001.631-1.39l4.772-16.075a1.964 1.964 0 00-.48-1.943"
  })));
}

export default SvgSendIcon;